import { render, staticRenderFns } from "./viewed.vue?vue&type=template&id=3a6a85e0"
import script from "./viewed.vue?vue&type=script&lang=ts"
export * from "./viewed.vue?vue&type=script&lang=ts"
import style0 from "./viewed.vue?vue&type=style&index=0&id=3a6a85e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports